import { takeEvery, call, all, put, select } from 'redux-saga/effects';
import {
  SubmissionSearch,
  searchSubmissions,
  updateSubmission,
  deleteSubmission,
} from '@kineticdata/react';

import {
  actions as errorActions,
  NOTICE_TYPES,
} from 'gbmembers/src/redux/modules/errors';
import { types, actions } from '../modules/journeyTriggers';
const util = require('util');

export const JOURNEY_GROUPS_SEARCH = new SubmissionSearch(true)
  .include('details,values')
  .limit(1000)
  .build();

export const JOURNEY_TRIGGERS_SEARCH = new SubmissionSearch(true)
  .include('details,values')
  .limit(1000)
  .build();

export const TEMPLATES_SEARCH = new SubmissionSearch(true)
  .include('details,values')
  .limit(1000)
  .build();

export function* fetchJourneyEvents(action) {
  try {
    var search = undefined;
    if (
      action.payload.triggerID !== null &&
      action.payload.memberID === null &&
      action.payload.leadID === null
    ) {
      search = new SubmissionSearch(true)
        .eq('values[Trigger ID]', action.payload.triggerID)
        .index('values[Trigger ID]')
        .includes(['details', 'values'])
        .sortDirection('DESC')
        .limit(50)
        .build();
    } else if (
      action.payload.triggerID !== null &&
      action.payload.memberID !== null &&
      action.payload.leadID === null
    ) {
      search = new SubmissionSearch(true)
        .eq('values[Record ID]', action.payload.memberID)
        .eq('values[Trigger ID]', action.payload.triggerID)
        .index('values[Record ID],values[Trigger ID]')
        .includes(['details', 'values'])
        .sortDirection('DESC')
        .limit(50)
        .build();
    } else if (
      action.payload.triggerID !== null &&
      action.payload.memberID === null &&
      action.payload.leadID !== null
    ) {
      search = new SubmissionSearch(true)
        .eq('values[Record ID]', action.payload.leadID)
        .eq('values[Trigger ID]', action.payload.triggerID)
        .index('values[Record ID],values[Trigger ID]')
        .includes(['details', 'values'])
        .sortDirection('DESC')
        .limit(50)
        .build();
    } else if (
      action.payload.triggerID == null &&
      action.payload.memberID !== null &&
      action.payload.leadID == null
    ) {
      search = new SubmissionSearch(true)
        .eq('values[Record ID]', action.payload.memberID.value)
        .index('values[Record ID]')
        .includes(['details', 'values'])
        .sortDirection('DESC')
        .limit(50)
        .build();
    } else if (
      action.payload.triggerID == null &&
      action.payload.memberID === null &&
      action.payload.leadID !== null
    ) {
      search = new SubmissionSearch(true)
        .eq('values[Record ID]', action.payload.leadID.value)
        .index('values[Record ID]')
        .includes(['details', 'values'])
        .sortDirection('DESC')
        .limit(50)
        .build();
    }
    const { submissions, serverError } = yield call(searchSubmissions, {
      get: true,
      form: 'journey-event',
      search: search,
      datastore: true,
    });

    if (serverError) {
      yield put(errorActions.addError(serverError));
    } else {
      yield put(
        actions.setJourneyEvents({
          events: submissions,
        }),
      );
    }
  } catch (error) {
    console.log('Error in fetchJourneyEvents: ' + util.inspect(error));
  }
}

export function* fetchTemplates() {
  try {
    const { emailTemplates, smsTemplates, scriptTemplates } = yield all({
      emailTemplates: call(searchSubmissions, {
        get: true,
        datastore: true,
        form: 'email-templates',
        search: TEMPLATES_SEARCH,
      }),
      smsTemplates: call(searchSubmissions, {
        get: true,
        datastore: true,
        form: 'sms-templates',
        search: TEMPLATES_SEARCH,
      }),
      scriptTemplates: call(searchSubmissions, {
        get: true,
        datastore: true,
        form: 'call-scripts',
        search: TEMPLATES_SEARCH,
      }),
    });
    yield put(
      actions.setTemplates({
        emailTemplates: emailTemplates.submissions || [],
        smsTemplates: smsTemplates.submissions || [],
        scriptTemplates: scriptTemplates.submissions || [],
      }),
    );
  } catch (error) {
    console.log('Error in fetchTemplates: ' + util.inspect(error));
  }
}

export function* fetchJourneyInfo() {
  try {
    const { groups, triggers } = yield all({
      groups: call(searchSubmissions, {
        get: true,
        datastore: true,
        form: 'trigger-groups',
        search: JOURNEY_GROUPS_SEARCH,
      }),
      triggers: call(searchSubmissions, {
        get: true,
        datastore: true,
        form: 'journey-triggers',
        search: JOURNEY_TRIGGERS_SEARCH,
      }),
    });

    if (groups.serverError) {
      yield put(errorActions.addError(groups.serverError));
    } else if (triggers.serverError) {
      yield put(errorActions.addError(triggers.serverError));
    } else {
      var groupsSubmissions = groups.submissions;
      let groupsPageToken = groups.nextPageToken;
      while (groupsPageToken) {
        const nextGroupsPage = yield call(searchSubmissions, {
          get: true,
          datastore: true,
          form: 'trigger-groups',
          search: new SubmissionSearch(true)
            .include('details,values')
            .limit(1000)
            .pageToken(groupsPageToken)
            .build(),
        });
        groupsSubmissions = groupsSubmissions.concat(nextGroupsPage.submissions);
        groupsPageToken = nextGroupsPage.nextPageToken;
      }

      var triggerSubmissions = triggers.submissions;
      let triggersPageToken = triggers.nextPageToken;
      while (triggersPageToken) {
        const nextTriggersPage = yield call(searchSubmissions, {
          get: true,
          datastore: true,
          form: 'journey-triggers',
          search: new SubmissionSearch(true)
            .include('details,values')
            .limit(1000)
            .pageToken(triggersPageToken)
            .build(),
        });
        triggerSubmissions = triggerSubmissions.concat(nextTriggersPage.submissions);
        triggersPageToken = nextTriggersPage.nextPageToken;
      }

      yield put(
        actions.setJourneyInfo({
          groups: groupsSubmissions,
          triggers: triggerSubmissions,
        }),
      );
      yield call(fetchTemplates);
    }
  } catch (error) {
    console.log('Error in fetchJourneyInfo: ' + util.inspect(error));
  }
}

export function* updateJourneyTrigger({ payload }) {
  try {
    const { submission, serverError } = yield call(updateSubmission, {
      id: payload.id,
      values: payload.values,
      datastore: true,
      include: 'details,values',
    });

    if (serverError) {
      yield put(errorActions.addError(serverError));
    } else {
      payload.triggerUpdateCompleted(submission);
      yield put(
        errorActions.addSuccess(
          ['Journey Trigger updated successfully'],
          'Trigger Updated',
        ),
      );
    }
  } catch (error) {
    console.log('Error in updateJourneyTrigger: ' + util.inspect(error));
    yield put(errorActions.addError(error));
  }
}

export function* deleteTrigger(action) {
  try {
    console.log('deleteTrigger: ');
    const { errors, serverError } = yield call(deleteSubmission, {
      id: action.payload.id,
      datastore: true,
    });

    if (serverError) {
      yield put(errorActions.addError(serverError));
    } else {
      action.payload.completeTriggerDelete(action.payload.id);
    }

    yield put(
      errorActions.addSuccess(
        ['Journey Trigger deleted successfully'],
        'Delete Trigger',
      ),
    );
  } catch (error) {
    console.log('Error in deleteTrigger: ' + util.inspect(error));
    yield put(errorActions.addError([error], 'Delete Trigger'));
  }
}

export function* watchJourneyTriggers() {
  yield takeEvery(types.FETCH_JOURNEY_INFO, fetchJourneyInfo);
  yield takeEvery(types.FETCH_TEMPLATES, fetchTemplates);
  yield takeEvery(types.UPDATE_JOURNEY_TRIGGER, updateJourneyTrigger);
  yield takeEvery(types.DELETE_TRIGGER, deleteTrigger);
  yield takeEvery(types.FETCH_JOURNEY_EVENTS, fetchJourneyEvents);
}
